import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {DialogModel} from '@shared/models/dialog.model';
import {CreateSubAccountCommand, DeleteSubAccountCommand} from '@features/firm/commands/firm.commands';

@Injectable({
  providedIn: 'root',
})
export class SubAccountsHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();

  constructor(private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router,
              private dialogService: DialogService) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    if (command.name === 'CreateSubAccountDialogCommand') {
      this.openCreateSubAccountDialog();
      return;
    }
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(() => {
          this.invalidateSubject?.invalidate();
          this.fuseSplashScreenService.hide();
        },
        error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  valueChanged($event) {
    if ($event.action && $event.action.id === 'Delete') {
      this.deleteSubAccount($event);
      return;
    }
    if ($event.action && $event.action.id === 'Detach') {
      this.detachSubAccount($event);
      return;
    }
    if ($event.fieldDefinition?.key === 'AccountId' || $event.fieldDefinition?.key === 'Users') {
      this.router.navigateByUrl(`/firm/sub-accounts/${$event.item.id}`);
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  private openCreateSubAccountDialog() {
    const dialogModel = DialogModel.create('Create Sub Account', 'AddSubAccountDialogComponent', {}, '600px', '800px');
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(state => {
      if (state.action === 'OK') {
        const command = new CreateSubAccountCommand(state.data.input.accountName, state.data.input.description);
        this.commandService.executeCommand(command).pipe(take(1)).subscribe(() => {
          this.invalidateSubject?.invalidate();
        });
      }
    });
  }

  private deleteSubAccount($event) {
    this.dialogService.showYesNoDialog('Delete Sub Account', 'Are you sure you want to delete this sub account?')
      .pipe(take(1)).subscribe(result => {
        if (result.action === 'OK') {
          const command = new DeleteSubAccountCommand([$event.item.id]);
          this.commandService.executeCommand(command).pipe(take(1)).subscribe(() => {
            this.invalidateSubject?.invalidate();
          });
        }
      });
  }

  private detachSubAccount($event) {
    this.dialogService.showYesNoDialog(
      'Detach Sub Account',
      'Detaching removes the firm link from this sub account’s company record. This action cannot be undone. Do you want to continue?'
    ).pipe(take(1)).subscribe(result => {
      if (result.action === 'OK') {
        const command = new PlatformCommand('DetachSubAccountCommand', Api.AdminPanel);
        command.setValue('SubAccountIds', [$event.item.id]);
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(() => {
          this.invalidateSubject?.invalidate();
        });
      }
    });
  }
}
